import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';
import { schemaEuropaceAntragstellerzuordnung } from '../../Antragstellerzuordnung.schema';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#lebensversicherung

	{
		"gehoertZuAntragsteller": Antragstellerzuordnung,
		"praemieMonatlich": schemaBigDecimal,
		"rueckkaufswert": schemaBigDecimal,
	}

*/

export const schemaEuropaceLebensversicherung = z.object({
    europaceId: z.optional(z.string().min(1)),
    gehoertZuAntragsteller: z.optional(schemaEuropaceAntragstellerzuordnung),
    id: z.string().min(1),
    praemieMonatlich: z.optional(schemaBigDecimal),
    rueckkaufswert: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceLebensversicherung = z.infer<typeof schemaEuropaceLebensversicherung>;
